import React from "react";
import { NewsData } from "../../../../lib/types";
import AllianceInfoLink from "../../../Common/AllianceInfoLink";

interface IProps {
  gameNews: NewsData;
}

const NewsGame = ({ gameNews }: IProps) => (
  <>
    <h2 className="h2">
    <span className="bordered addons">
        Ongoing wars
        <span className="addon"/>
    </span>
    </h2>
    <span className="divider"/>
    <div className="boxes-group">
      <div className="box text-info news-item">
        {gameNews.wars && gameNews.wars.length ? gameNews.wars.length && gameNews.wars.map(war => (
          <div className="text-item">
            <AllianceInfoLink name={war.coalitionA.name} allianceId={war.coalitionA.id} />&nbsp;
            <i className="icon icon-armada middle"/>
            &nbsp;<AllianceInfoLink name={war.coalitionB.name} allianceId={war.coalitionB.id} />
            <div>
              Progress: {war.duration}/5<br/>
              War points: <em>{war.warPointsA}</em> : <em>{war.warPointsB}</em><br/>
              {war.duration > 0
              && <>Alliance <em>{war.countWinner.name}</em> won last count<br/></>}
              {war.duration === 5
              && <>War has finished - {war.winner
                ? <>the winner is <em>{war.winner.name}</em></>
                : <em>draw</em>}</>}
            </div>
          </div>)) : <div className="box text-info text-item">No ongoing wars</div>}
          <div className={"text-item"}>
            Applications for war: <em>{gameNews.warApplications}</em>
          </div>
      </div>
    </div>
  </>
)

export default NewsGame;
